export default "__VITE_ASSET__43da30ba__"